import React, { Component } from "react";
import SegmentTable from "../Table";
import "../segmentlist.css";
import { getUrlParameterByName } from "../../../../utils/utility";
class Active extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortOrder: "desc",
      sortName: "Date Created",
      sortColumn: "createdTime",
      tableHeadData: ["DATE", "AUDIENCE SEGMENTS", "COUNT", "CLIENT"],
      showNoSegment: "",
      pageNumber: 1,
    };
    this.throttle = true;
  }
  componentDidMount() {
    this.props.clearReactiveStatus();
    if (!getUrlParameterByName("cid")) {
      this.props.getSegmentList({
        source: this.props.sourceType,
        clientId: this.props.selected_client,
        pageNumber: 1,
        sortColumn: "createdTime",
        pageSize: 10,
        status: "Active",
        order: "desc",
      });
      this.props.history.push(
        "/segments/list/active?cid=" + this.props.selected_client,
      );
    }
    const cid = parseInt(getUrlParameterByName("cid"), 10);
    if (cid > 0) {
      this.props.selectClient(cid);
      this.props.getSegmentList({
        source: this.props.sourceType,
        clientId: cid,
        pageNumber: 1,
        sortColumn: "createdTime",
        pageSize: 10,
        status: "Active",
        order: "desc",
      });
    }

    if (!this.props.demoAttributes) {
      this.props.loadAttributes(cid);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.selected_client === "0") {
      this.setState({
        tableHeadData: ["DATE", "AUDIENCE SEGMENTS", "COUNT", "CLIENT"],
      });
    } else {
      this.setState({
        tableHeadData: [
          "Select",
          "Audience Name",
          "Date Created",
          "Source",
          "Status",
        ],
      });
    }
    if (nextProps.selected_client !== this.props.selected_client) {
      if (
        (typeof nextProps.selected_client === "string" &&
          nextProps.selected_client.indexOf("r-") < 0) ||
        parseInt(nextProps.selected_client, 10) > 0
      )
        this.props.getSegmentList({
          source: this.props.sourceType,
          clientId:
            parseInt(nextProps.selected_client, 10) >= 0
              ? nextProps.selected_client
              : null,
          pageNumber: this.state.pageNumber,
          sortColumn: "createdTime",
          pageSize: 10,
          status: "Active",
          order: "desc",
        });
      this.props.history.push(
        "/segments/list/active?cid=" + nextProps.selected_client,
      );
    }

    if (nextProps.segment_list_active.data.length > 0) {
      this.setState({
        showNoSegment: false,
      });
    } else {
      this.setState({
        showNoSegment: true,
      });
    }
    if (nextProps.sourceType !== this.props.sourceType) {
      this.setState({
        sortColumn: "createdTime",
        cache_sortColumn: "createdTime",
        sortName: "Date Created",
      });
    }
    // console.log(nextProps.segment_list_active.data.length)
  }
  handleHeaderClick(targetText, pageIndex) {
    this.setState({
      cache_sortColumn: targetText,
    });
    let obj = {
      sortOrder:
        this.state.sortOrder === "desc" &&
        this.state.cache_sortColumn === targetText
          ? "asc"
          : "desc",
      sortName: targetText,
    };
    switch (targetText) {
      case "Date Created":
        obj = {
          ...obj,
          sortColumn: "createdTime",
        };
        break;
      case "Audience Name":
        obj = {
          ...obj,
          sortColumn: "name",
        };
        break;
      case "Status":
        obj = {
          ...obj,
          sortColumn: "status",
        };
        break;
      case "Source":
        obj = {
          ...obj,
          sortColumn: "source",
        };
        break;
      case "CLIENT":
        obj = {
          ...obj,
          sortColumn: "clientId",
        };
        break;
      default:
        return;
    }

    this.setState(obj, () => {
      this.dispatchPageAction(pageIndex);
    });
  }
  handlePageClick(page) {
    this.dispatchPageAction(page);
  }
  goNext(page) {
    this.dispatchPageAction(page);
  }
  goPrevious(page) {
    this.dispatchPageAction(page);
  }
  selectRows(page, row) {
    this.setState(
      {
        pageSize: row,
      },
      () => {
        this.dispatchPageAction(page);
      },
    );
  }
  goToPage(page) {
    if (page > this.props.segment_list_active.pageCount) {
      return;
    } else {
      this.dispatchPageAction(page);
    }
  }
  dispatchPageAction(page, order = "") {
    this.setState({
      pageNumber: page,
    });
    this.props.recordActiveQueryParams({
      sortColumn: this.state.sortColumn,
      pageNumber: page,
      pageSize: this.state.pageSize,
      order: this.state.sortOrder,
    });
    this.props.getSegmentList({
      source: this.props.sourceType,
      clientId:
        parseInt(this.props.selected_client, 10) > 0
          ? this.props.selected_client
          : null,
      sortColumn: this.state.sortColumn,
      pageNumber: page,
      pageSize: this.state.pageSize,
      status: "Active",
      order: this.state.sortOrder,
    });
  }
  nextGroup(page) {
    this.dispatchPageAction(page);
  }
  previousGroup(page) {
    this.dispatchPageAction(page);
  }
  handleArchiveSegment(id) {
    this.props.archiveSegment(id);
  }
  updateSegmentList(page) {
    this.dispatchPageAction(page);
  }
  handleCreateSegmentClick() {
    this.props.history.push("/segment/create");
  }
  handleIconClick(targetText, pageIndex) {
    let obj = {
      sortOrder: this.state.sortOrder === "desc" ? "asc" : "desc",
      sortName: targetText,
    };
    switch (targetText) {
      case "Date Created":
        obj = {
          ...obj,
          sortColumn: "createdTime",
        };
        break;
      case "Audience Name":
        obj = {
          ...obj,
          sortColumn: "name",
        };
        break;
      case "Status":
        obj = {
          ...obj,
          sortColumn: "status",
        };
        break;
      case "Source":
        obj = {
          ...obj,
          sortColumn: "source",
        };
        break;
      case "CLIENT":
        obj = {
          ...obj,
          sortColumn: "clientId",
        };
        break;
      default:
        return;
    }

    this.setState(obj, () => {
      this.dispatchPageAction(pageIndex);
    });
  }
  closeCreateCampaignDialog() {
    // close create audience file pop out
    this.props.closeCreateCampaignDialog();
  }
  checkBoxBeClick() {
    this.props.checkBoxBeClick();
  }
  render() {
    const {
      segment_list_active,
      archive_success,
      segment_attributes,
      segment_summary,
      fetchSegmentDetail,
      clearSegmentSummary,
      demoAttributes,
      geoAttributes,
    } = this.props;
    return (
      <div className="segment-active">
        {!this.state.showNoSegment ? (
          <SegmentTable
            checkBoxBeClick={() => this.checkBoxBeClick()}
            selectedSegment={this.props.selectedSegment}
            ifCreateAudienceFile={this.props.ifCreateAudienceFile}
            closeCreateCampaignDialog={() => this.closeCreateCampaignDialog()}
            tableHeaderArray={this.state.tableHeadData}
            client_info={this.props.client_info}
            data={segment_list_active}
            demoAttributes={demoAttributes}
            geoAttributes={geoAttributes}
            fetchSegmentDetail={fetchSegmentDetail}
            clearSegmentSummary={clearSegmentSummary}
            segment_summary={segment_summary}
            headerBeClick={(text, pageIndex) =>
              this.handleHeaderClick(text, pageIndex)
            }
            pageBeClick={page => this.handlePageClick(page)}
            nextBeClick={page => this.goNext(page)}
            previousBeClick={page => this.goPrevious(page)}
            nextGroupBeClick={page => this.nextGroup(page)}
            previousGroupBeClick={page => this.previousGroup(page)}
            selectRows={(page, row) => this.selectRows(page, row)}
            goToPage={page => this.goToPage(page)}
            segment_attributes={segment_attributes}
            sort={this.state.sortOrder}
            sortName={this.state.sortName}
            archiveSegment={id => this.handleArchiveSegment(id)}
            ifArchiveSuccess={archive_success}
            history={this.props.history}
            getSegmentWithRules={this.props.getSegmentWithRules}
            segment_active_creation={this.props.segment_active_creation} // create segment state
            active_segment_attributes={this.props.active_segment_attributes} // use selected attributes
            flag="active"
            updateSegmentList={page => this.updateSegmentList(page)}
            save_segment_report_id={this.props.save_segment_report_id}
            getCreateCampaign={this.props.getCreateCampaign} // create campaign api function
            create_campaign={this.props.create_campaign}
            rollbackRequestSuccessToFalse={
              this.props.rollbackRequestSuccessToFalse
            }
            roleName={this.props.roleName}
            selectedSegmentSetArray={this.props.selectedSegmentSetArray}
            selectedClientChanged={this.props.selectClient}
            handleIconClick={(targetName, targetIndex) =>
              this.handleIconClick(targetName, targetIndex)
            }
            handleConfirmArchive={() => this.props.handleConfirmArchive()}
          />
        ) : (
          <section style={{ textAlign: "center", fontSize: "1.5em" }}>
            You have no saved segments.
          </section>
        )}
        <div>
          {/*{*/}
          {/*(parseInt(selected_client) > 0) ? */}
          {/*<button type="button" disabled={this.props.roleId > 3 && client_info && client_info.subscription && client_info.subscription.id > 1 } className="btn btn-default legitRipple segments-create" onClick={(e)=>{this.handleCreateSegmentClick.bind(this)}}>*/}
          {/*<Link to="/segment/create">Create an Audience Name </Link>*/}
          {/*</button> : <button disabled type="button" className="btn btn-default legitRipple segments-create">*/}
          {/*Create an Audience Name*/}
          {/*</button>*/}
          {/*}*/}
        </div>
      </div>
    );
  }
}

export default Active;



// WEBPACK FOOTER //
// ./src/components/Segment/List/Active/Active.jsx